export const GameUtils =  {};

GameUtils.giveMoney = (money) => {
    if(!money) {
        Yosemite.McManager.addMoney(500);
    } else {
        Yosemite.McManager.addMoney(money);
    }
}

GameUtils.anastasia = {
    activateFirstTalk: () => {
        Yosemite.EventStateManager.state.coffeeShop.anastasia.firstTalk = false;
        Yosemite.EventStateManager.anastasiaDailyEventChecked = false;
    },

    activateSecondTalk: () => {
        Yosemite.EventStateManager.state.coffeeShop.anastasia.firstTalk = true;
        Yosemite.EventStateManager.anastasiaDailyEventChecked = false;
    },

    activateGenericTalk: () => {
        Yosemite.EventStateManager.anastasiaDailyEventChecked = true;
    },
    activateGenericTalk_1: () => {
        Yosemite.EventStateManager.state.coffeeShop.anastasia.firstTalk = true;
        Yosemite.EventStateManager.state.coffeeShop.anastasia.secondTalk = false;
        Yosemite.EventStateManager.state.waifu.anastasia.dayEventChecked = true;
    },
    activateGenericTalk_2: () => {
        GameUtils.anastasia.activateGenericTalk_1();
        Yosemite.EventStateManager.state.coffeeShop.anastasia.secondTalk = true;
        Yosemite.McManager.setFitness(3);
        Yosemite.EventStateManager.anastasiaBeachFirstRequest = true;
        YsServices.questService.activate(YsServices.questService.questEnum.RubinaGymTip);
    },
    activateGenericTalk_3: () => {
        GameUtils.anastasia.activateGenericTalk_1();
        Yosemite.EventStateManager.state.coffeeShop.anastasia.secondTalk = true;
        Yosemite.McManager.setFitness(7);

        Yosemite.EventStateManager.anastasiaBeachFirstRequest = true;
        YsServices.questService.complete(YsServices.questService.questEnum.RubinaGymTip);
    },
    activateGenericTalk_4: () => {
        GameUtils.anastasia.activateFirstRestaurantDate();
        Yosemite.EventStateManager.state.coffeeShop.anastasia.firstRestaurantDate = true;
        Yosemite.EventStateManager.state.coffeeShop.anastasia.firstSexEvent = false;
        YsControllers.TimeController.setMorning();
    },
    activateGenericTalk_5: () => {
        GameUtils.anastasia.activateFirstSexEvent();
        Yosemite.EventStateManager.state.coffeeShop.anastasia.firstSexEvent = true;
        YsControllers.TimeController.setMorning();
    },
    activateBeachFirstRequest: () => {
        Yosemite.McManager.setFitness(2);
        Yosemite.EventStateManager.state.coffeeShop.anastasia.firstTalk = true;
        Yosemite.EventStateManager.state.coffeeShop.anastasia.secondTalk = true;
        Yosemite.EventStateManager.anastasiaDailyEventChecked = false;
        Yosemite.EventStateManager.anastasiaBeachFirstRequest = false;
    },
    activateGenericBeachDate: () => {
        GameUtils.anastasia.activateBeachFirstRequest();
        Yosemite.McManager.setFitness(7);
        YsServices.questService.complete(YsServices.questService.questEnum.RubinaGymTip, false);
        Yosemite.EventStateManager.anastasiaBeachFirstRequest = true;
    },
    activateFirstRestaurantDate: () => {
        GameUtils.anastasia.activateBeachFirstRequest();
        Yosemite.EventStateManager.anastasiaBeachFirstRequest = true;
        Yosemite.EventStateManager.anastasiaDailyEventChecked = false;
        Yosemite.EventStateManager.anastasiaFirstRestaurantDate = false;
        Yosemite.McManager.setFitness(7);
    },
    activateFirstKissDate: () => {
        GameUtils.anastasia.activateFirstRestaurantDate();
        Yosemite.EventStateManager.anastasiaFirstRestaurantDate = true;
        Yosemite.EventStateManager.anastasiaDailyEventChecked = false;
        Yosemite.EventStateManager.anastasiaFirstKissDate = false;
        Yosemite.McManager.setFitness(7);
        YsServices.questService.complete(YsServices.questService.questEnum.AnimalShelter, false);
        YsControllers.TimeController.setMorning();
    },
    activateFirstBirthday: () => {
        GameUtils.anastasia.activateFirstKissDate();
        Yosemite.EventStateManager.anastasiaFirstKissDate = true;
        Yosemite.EventStateManager.anastasiaDailyEventChecked = false;
        Yosemite.EventStateManager.anastasiaFirstBirthday = false;
        Yosemite.McManager.setFitness(7);
        YsServices.questService.complete(YsServices.questService.questEnum.BirthdayGift, false);
        YsControllers.TimeController.setMorning();
    },
    activateFirstSexEvent: () => {
        GameUtils.anastasia.activateFirstBirthday();
        Yosemite.EventStateManager.anastasiaFirstBirthday = true;
        Yosemite.EventStateManager.anastasiaDailyEventChecked = false;
        Yosemite.EventStateManager.anastasiaFirstSexEvent = false;
        Yosemite.McManager.setFitness(10);
        YsControllers.TimeController.setMorning();
    },
    activateUnplannedVisit: () => {
        GameUtils.anastasia.activateFirstSexEvent();
        Yosemite.EventStateManager.anastasiaFirstSexEvent = true;
        EventStateService.state.waifu.samantha.firstEvent = true;
        Yosemite.EventStateManager.anastasiaDailyEventChecked = false;
    },
    activateMeetingVicky: () => {
        GameUtils.anastasia.activateUnplannedVisit();
        EventStateService.state.waifu.anastasia.unplannedVisit = true;
        EventStateService.state.waifu.anastasia.meetingVicky = false;
        EventStateService.state.gym.vicky.jogging = true;
        Yosemite.EventStateManager.anastasiaDailyEventChecked = false;
    },
    activateMeetingParents: () => {
        GameUtils.anastasia.activateMeetingVicky();
        EventStateService.state.waifu.anastasia.meetingVicky = true;
        EventStateService.state.waifu.anastasia.meetingParents = false;
        Yosemite.EventStateManager.anastasiaDailyEventChecked = false;
    },
    activateDisappear: () => {
        GameUtils.anastasia.activateMeetingParents();
        EventStateService.state.waifu.anastasia.meetingParents = true;
        EventStateService.state.waifu.anastasia.disappear = false;
        Yosemite.EventStateManager.anastasiaDailyEventChecked = false;
    }
}

GameUtils.vicky = {
    activateGenericTalk1: () => {
        Yosemite.EventStateManager.state.gym.vicky.firstTalk = true;
        Yosemite.EventStateManager.state.waifu.vicky.dayEventChecked = true;
        $gameSelfSwitches.setValue([13, 8, 'A'], true);
    },
    activateGenericTalk2: () => {
        Yosemite.EventStateManager.state.gym.vicky.firstTalk = true;
        Yosemite.EventStateManager.state.gym.vicky.secondTalk = true;
        Yosemite.EventStateManager.state.waifu.vicky.dayEventChecked = true;
        $gameSelfSwitches.setValue([13, 8, 'A'], true);
    },
    activateGenericTalk3: () => {
        GameUtils.vicky.activateJoggingEvent();
        Yosemite.EventStateManager.state.gym.vicky.jogging = true;
        Yosemite.EventStateManager.state.waifu.vicky.dayEventChecked = true;
    },
    activateGenericTalk4: () => {
        GameUtils.vicky.activateTrainingEvent();
        Yosemite.EventStateManager.state.gym.vicky.training = true;
        Yosemite.EventStateManager.state.waifu.vicky.dayEventChecked = true;
    },
    activateFirstTalk: () => {
        Yosemite.EventStateManager.state.gym.vicky.firstTalk = false;
        Yosemite.EventStateManager.state.waifu.vicky.dayEventChecked = false;
        $gameSelfSwitches.setValue([13, 8, 'A'], false);
    },
    activateSecondTalk: () => {
        GameUtils.vicky.activateFirstTalk();
        $gameSelfSwitches.setValue([13, 8, 'A'], true);
        Yosemite.EventStateManager.state.gym.vicky.firstTalk = true;
        Yosemite.EventStateManager.state.gym.vicky.secondTalk = false;
        Yosemite.McManager.setIntelligence(2);
    },
    activateVickyFirstDate: () => {
        GameUtils.vicky.activateSecondTalk();
        Yosemite.EventStateManager.state.gym.vicky.secondTalk = true;
        YsServices.questService.activate(13);
        YsControllers.TimeController.setEvening();
        Yosemite.EventStateManager.vickyFirstDate = true
    },
    activateJoggingEvent: () => {
        GameUtils.vicky.activateVickyFirstDate();
        YsServices.questService.complete(13, false);
        Yosemite.EventStateManager.vickyFirstDate = false;
        Yosemite.EventStateManager.state.gym.vicky.jogging = false;

        Yosemite.McManager.setIntelligence(6);
    },
    activateGenericTalkJogging: () => {
        Yosemite.EventStateManager.state.gym.vicky.firstTalk = true;
        Yosemite.EventStateManager.state.gym.vicky.secondTalk = true;
        Yosemite.EventStateManager.state.gym.vicky.jogging = true;
        Yosemite.EventStateManager.vickyDailyEventChecked = false;

        Yosemite.McManager.setIntelligence(6);
        $gameSelfSwitches.setValue([13, 8, 'A'], true);
    },
    activateBeachEvent: () => {
        GameUtils.vicky.activateJoggingEvent();
        Yosemite.EventStateManager.state.gym.vicky.jogging = true;
        Yosemite.McManager.setIntelligence(8);
    },
    activateTrainingEvent: () => {
        GameUtils.vicky.activateBeachEvent();
        Yosemite.EventStateManager.state.gym.vicky.beach = true;
        Yosemite.EventStateManager.state.gym.vicky.training = false;
        Yosemite.McManager.setIntelligence(8);
    },
    activateFirstMeetingAnastasiaInPub: () => {
        GameUtils.vicky.activateTrainingEvent();
        Yosemite.EventStateManager.state.gym.vicky.training = true;
        Yosemite.EventStateManager.state.waifu.vicky.firstMeetingAnastasiaInPub = false;
    },
    activateFirstTripToHome: () => {
        GameUtils.vicky.activateFirstMeetingAnastasiaInPub();
        Yosemite.EventStateManager.state.waifu.vicky.firstMeetingAnastasiaInPub = true;
        Yosemite.EventStateManager.state.waifu.vicky.firstTripToHome = false;
    },
    activateTournamentTrip: () => {
        GameUtils.vicky.activateFirstTripToHome();
        Yosemite.EventStateManager.state.waifu.vicky.firstTripToHome = true;
        Yosemite.EventStateManager.state.waifu.vicky.tournamentTrip = false;
    },
    activateParkKiss: () => {
        GameUtils.vicky.activateTournamentTrip();
        Yosemite.EventStateManager.state.waifu.vicky.tournamentTrip = true;
        Yosemite.EventStateManager.state.waifu.vicky.parkKiss = false;
    }
}

GameUtils.lisa = {
    activateEvent1: () => {
        if(YsServices.questService.status(6) !== 0) {
            YsServices.questService.activate(6);
        }
        YsServices.questService.completeQuest(6, true, true);
        YsControllers.TimeController.setEvening();
        GameUtils.completeChapter1();
        EventStateService.secondChapterIntro = true;
        Yosemite.EventStateManager.state.waifu.lisa.dayEventChecked = false;
    },
    activateBarParty: () => {
        GameUtils.lisa.activateEvent1();
        EventStateService.state.waifu.lisa.firstEvent = true;
        EventStateService.state.waifu.lisa.barParty = false;
    },
    activateBeachEvent: () => {
        GameUtils.lisa.activateBarParty();
        EventStateService.state.waifu.lisa.barParty = true;
        EventStateService.state.waifu.lisa.beachMeeting = false;
    },
    activateCookieEvent: () => {
        GameUtils.lisa.activateBeachEvent();
        EventStateService.state.waifu.lisa.beachMeeting = true;
        EventStateService.state.waifu.lisa.cookie = false;
    },
    activateHelpingInBar: () => {
        GameUtils.lisa.activateCookieEvent();
        EventStateService.state.waifu.lisa.cookie = true;
        EventStateService.state.waifu.lisa.helpingInBar = false;
    },
    activateMeetingElenInPark: () => {
        GameUtils.lisa.activateHelpingInBar();
        EventStateService.state.waifu.lisa.helpingInBar = true;
        EventStateService.state.waifu.lisa.meetingElenInPark = false;
    },
    activateArgumentinBar: () => {
        GameUtils.lisa.activateMeetingElenInPark();
        EventStateService.state.waifu.lisa.meetingElenInPark = true;
        EventStateService.state.waifu.lisa.argumentInBar = false;
    },
    activatePubAftermath: () => {
        GameUtils.lisa.activateArgumentinBar();
        EventStateService.state.waifu.elen.pubAftermath = true;
        EventStateService.state.waifu.lisa.argumentInBar = true;
        EventStateService.state.waifu.lisa.pubAftermath = false;
        EventStateService.elenPubAftermathChoice = true;
    },
    activateLisaBreakdown: () => {
        GameUtils.lisa.activatePubAftermath();
        EventStateService.state.waifu.elen.beachTrip = true;
        EventStateService.state.waifu.lisa.pubAftermath = true;
        EventStateService.elenPubAftermathChoice = true;
    },
    activateLisaConclusion: () => {
        GameUtils.lisa.activateLisaBreakdown();
        EventStateService.state.waifu.elen.beachTrip = true;
        EventStateService.state.waifu.lisa.breakdown = true;
        EventStateService.elenPubAftermathChoice = true;
    }
}

GameUtils.samantha = {
    activateEvent3: () => {
        EventStateService.state.waifu.samantha.firstEvent = true;
        EventStateService.state.waifu.samantha.secondEvent = true;
        EventStateService.state.waifu.samantha.thirdEvent = false;
        EventStateService.state.waifu.samantha.dayEventChecked = false;
    },
    activateEvent4: () => {
        EventStateService.state.waifu.samantha.firstEvent = true;
        EventStateService.state.waifu.samantha.secondEvent = true;
        EventStateService.state.waifu.samantha.thirdEvent = true;
        EventStateService.state.waifu.samantha.fourthEvent = false;
        EventStateService.state.waifu.samantha.dayEventChecked = false;
        YsControllers.TimeController.setEvening();
    },
    activateEvent6: () => {
        GameUtils.samantha.activateEvent4();
        EventStateService.state.waifu.samantha.fourthEvent = true;
        EventStateService.state.waifu.samantha.fifthEvent = true;
        EventStateService.state.waifu.samantha.sixEvent = false;
        YsControllers.TimeController.setEvening();
    },
    activateEvent7: () => {
        GameUtils.samantha.activateEvent6();
        GameUtils.anastasia.activateMeetingVicky();
        EventStateService.state.waifu.samantha.fourthEvent = true;
        EventStateService.state.waifu.samantha.fifthEvent = true;
        EventStateService.state.waifu.samantha.sixEvent = true;
        EventStateService.state.waifu.samantha.seventhEvent = false;
    },
    activatePornoRecording: () => {
        GameUtils.samantha.activateEvent7();
        EventStateService.state.waifu.samantha.seventhEvent = true;
        EventStateService.state.waifu.samantha.pornRecording = false;
    }
}

GameUtils.jessica = {
    activateSecondBarEvent: () => {
        Yosemite.McManager.addMoney(500);
        YsControllers.TimeController.setEvening();
        Yosemite.McManager.setCharm(3);
        EventStateService.jessicaFirstBarEvent = true;
        EventStateService.jessicaDailyEventChecked = false;
        EventStateService.jessicaSecondBarEvent = false;
    },
    activateThirdBarEvent: () => {
        GameUtils.jessica.activateSecondBarEvent();
        YsControllers.TimeController.setEvening();
        EventStateService.jessicaSecondBarEvent = true;
        EventStateService.jessicaDailyEventChecked = false;
        EventStateService.jessicaThirdBarEvent = false;
    },
    activateFourthBarEvent: () => {
        GameUtils.jessica.activateThirdBarEvent();
        YsControllers.TimeController.setEvening();
        EventStateService.jessicaThirdBarEvent = true;
        EventStateService.jessicaDailyEventChecked = false;
        EventStateService.jessicaFourthBarEvent = false;
    },
    activateFirstBlowjob: () => {
        GameUtils.jessica.activateFourthBarEvent();
        YsControllers.TimeController.setEvening();
        EventStateService.jessicaFourthBarEvent = true;
        EventStateService.jessicaDailyEventChecked = false;
        EventStateService.isFirstBlowjob = false;
    },
    activateFirstEvent: () => {
        EventStateService.secondChapterIntro = true;
        EventStateService.state.waifu.jessica.firstBlowjob = true;
        YsControllers.TimeController.setEvening();
        Yosemite.McManager.addMoney(500);
        EventStateService.jessicaDailyEventChecked = false;
        EventStateService.jessicaFirstEvent = false;
    },
    activateSecondEvent: () => {
        GameUtils.jessica.activateFirstEvent();
        EventStateService.jessicaFirstBlowjob = true;
        EventStateService.state.waifu.jessica.firstEvent = true;
        EventStateService.state.waifu.jessica.secondEvent = false;
        EventStateService.state.waifu.jessica.dayEventChecked = false;
        Yosemite.McManager.addMoney(500);
    },
    activateThirdEvent: () => {
        GameUtils.jessica.activateSecondEvent();
        EventStateService.secondChapterIntro = true;
        EventStateService.jessicaSecondEvent = true;
        EventStateService.jessicaThirdEvent = false;
        EventStateService.jessicaFirstBlowjob = true;
        Yosemite.McManager.addMoney(500);
        EventStateService.jessicaDailyEventChecked = false;
    },
    activateFourthEvent: () => {
        GameUtils.jessica.activateThirdEvent();
        EventStateService.secondChapterIntro = true;
        EventStateService.jessicaThirdEvent = true;
        EventStateService.jessicaFourthEvent = false;
        EventStateService.jessicaFirstBlowjob = true;
        Yosemite.McManager.addMoney(500);
        EventStateService.jessicaDailyEventChecked = false;
    },
    activateJessicaBeachEvent: () => {
        GameUtils.jessica.activateFourthEvent();
        EventStateService.secondChapterIntro = true;
        EventStateService.jessicaFourthEvent = true;
        EventStateService.jessicaBeachEvent = false;
        EventStateService.jessicaFirstBlowjob = true;
        Yosemite.McManager.addMoney(500);
        EventStateService.jessicaDailyEventChecked = false;
    }
}

GameUtils.tina = {
    activateFirstEvent: () => {
        EventStateService.secondChapterIntro = true;
        EventStateService.tinaDailyEventChecked = false;
        Yosemite.EventStateManager.state.marketing.timesWorked = 4;
        YsControllers.TimeController.setMorning();
        EventStateService.dianaFirstEvent = true;
        EventStateService.tinaFirstEvent = false;
    },
    activatePeekIntoPast: () => {
        GameUtils.tina.activateFirstEvent();
        EventStateService.tinaFirstEvent = true;
        EventStateService.tinaPeekIntoPast = false;
        EventStateService.tinaDailyEventChecked = false;
        YsControllers.TimeController.setMorning();
    },
    activateLightHeartedJoy: () => {
        GameUtils.tina.activatePeekIntoPast();
        EventStateService.tinaPeekIntoPast = true;
        EventStateService.tinaLightHeartedJoy = false;
        EventStateService.tinaDailyEventChecked = false;
        YsControllers.TimeController.setMorning();
    },
    activateTinaRevelation: () => {
        GameUtils.tina.activateLightHeartedJoy();
        EventStateService.tinaLightHeartedJoy = true;
        EventStateService.tinaRevelation = false;
        EventStateService.tinaDailyEventChecked = false;
        YsControllers.TimeController.setMorning();
    },
}

GameUtils.diana = {
    activateFirstEvent: () => {
        EventStateService.secondChapterIntro = true;
        EventStateService.dianaDailyEventChecked = false;
        EventStateService.dianaFirstEvent = true;
    },
    activateFirstMeet: () => {
        GameUtils.diana.activateFirstEvent();
        EventStateService.dianaDailyEventChecked = false;
        YsControllers.TimeController.setMorning();
        Yosemite.EventStateManager.state.marketing.timesWorked = 4;
        EventStateService.dianaFirstEvent = true;
    },
    activateCuriosityEvent: () => {
        GameUtils.diana.activateFirstMeet();
        EventStateService.dianaDailyEventChecked = false;
        YsControllers.TimeController.setMorning();
        EventStateService.dianaFirstMeet = true;
    },
    activateSomberandheavyEvent: () => {
        GameUtils.diana.activateCuriosityEvent();
        EventStateService.dianaDailyEventChecked = false;
        YsControllers.TimeController.setMorning();
        EventStateService.dianaCuriosity = true;
    },
    activateRegretsEvent: () => {
        GameUtils.diana.activateSomberandheavyEvent();
        EventStateService.dianaDailyEventChecked = false;
        YsControllers.TimeController.setMorning();
        EventStateService.dianaSomberAndHeavy = true;
    },
    activateRevelationEvent: () => {
        GameUtils.diana.activateRegretsEvent();
        EventStateService.dianaDailyEventChecked = false;
        YsControllers.TimeController.setMorning();
        EventStateService.dianaRegrets = true;
    },
}

GameUtils.elen = {
    activateMeetLisa: () => {
        GameUtils.lisa.activateEvent1();
        EventStateService.state.waifu.lisa.firstEvent = true;
        EventStateService.secondChapterIntro = true;
        EventStateService.elenMeetingLisa = false;
        EventStateService.elenDailyEventChecked = false;
        YsControllers.TimeController.setMorning();
    }
}

GameUtils.annie = {
    activateSecondEvent: () => {
        Yosemite.EventStateManager.state.it.timesWorkedIT = 3;
        EventStateService.secondChapterIntro = true;
        EventStateService.annieDailyEventChecked = false;
        EventStateService.bartFirstEvent = true;
        EventStateService.annieSecondEvent = false;
        YsControllers.TimeController.setMorning();
    },
    activateAfterHours1: () => {
        GameUtils.annie.activateSecondEvent();
        EventStateService.annieSecondEvent = true;
        EventStateService.annieAfterHours1 = false;
        EventStateService.annieDailyEventChecked = false;
        YsControllers.TimeController.setAfternoon();
    }
}

GameUtils.testBrothel = () => {
    YsControllers.TimeController.setEvening();
    GameUtils.giveMoney();
}

GameUtils.testBarDrinking = () => {
    YsControllers.TimeController.setEvening();
    GameUtils.giveMoney();
    Yosemite.EventStateManager.state.drinkCount = 0;
}

GameUtils.testDrunkenMother = () => {
    if(YsServices.questService.status(8) !== 0) {
        YsServices.questService.activate(8);
    }
    YsControllers.TimeController.setEvening();
    Yosemite.McManager.addMoney(40);
    Yosemite.EventStateManager.state.bar.drunkenMotherTalked = false;
}

GameUtils.testJessicaGeneric = () => {
    GameUtils.giveMoney();
    Yosemite.EventStateManager.state.waifu.jessica.firstBlowjob = true;
    Yosemite.McManager.setCharm(11);
}

GameUtils.testJessicaEvent = () => {
    GameUtils.giveMoney();
    Yosemite.EventStateManager.state.waifu.jessica.firstBlowjob = false;
    Yosemite.McManager.setCharm(11);
}

GameUtils.completeChapter1 = () => {
    Yosemite.EventStateManager.state.coffeeShop.anastasia.firstTalk = true;
    Yosemite.EventStateManager.state.coffeeShop.anastasia.secondTalk = true;
    Yosemite.EventStateManager.state.coffeeShop.anastasia.beachFirstRequest = true;
    Yosemite.EventStateManager.state.coffeeShop.anastasia.firstRestaurantDate = true;
    Yosemite.EventStateManager.state.coffeeShop.anastasia.firstKissDate = true;
    Yosemite.EventStateManager.state.coffeeShop.anastasia.firstBirthday = true;
    Yosemite.EventStateManager.state.coffeeShop.anastasia.firstSexEvent = true;
    Yosemite.EventStateManager.state.mcHome.rubina.firstTalk = true;
    Yosemite.EventStateManager.state.gym.eliana.gymHint = true;
    Yosemite.EventStateManager.state.gym.rubina.gymTalk = true;
    EventStateService.secondChapterIntro = true;
    YsServices.questService.completeQuest(1, true, true);
    YsServices.questService.completeQuest(2, false, true);
    $gameSelfSwitches.setValue([Yosemite.PreEnterMap.mapsIdMap.coffeeShop, 5, 'A'], true);
    Yosemite.McManager.setFitness(10);
}

GameUtils.completeChapter2 = () => {
    GameUtils.completeChapter1();
    EventStateService.isJessicaWaifu = true;
    EventStateService.isSamanthaWaifu = true
    EventStateService.vickyParkKiss = true;
    EventStateService.secondChapterIntro = true;
    EventStateService.chapter2EndEvent = true;
}
